/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Machines_Status_RunningInputs */

const vi_tea_machines_status_running = /** @type {(inputs: Tea_Machines_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang chạy`)
};

/**

* @param {Tea_Machines_Status_RunningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_machines_status_running = /** @type {((inputs?: Tea_Machines_Status_RunningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Machines_Status_RunningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_machines_status_running(inputs)
});